const STORAGE_KEY = 'qroke-viewer-id';
let cachedId: string | null = null;

function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `guest-${Math.random().toString(36).slice(2, 11)}`;
}

export function getOrCreateViewerId(): string {
  if (cachedId) {
    return cachedId;
  }

  if (typeof window === 'undefined') {
    cachedId = generateId();
    return cachedId;
  }

  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) {
      cachedId = existing;
      return existing;
    }

    const newId = generateId();
    window.localStorage.setItem(STORAGE_KEY, newId);
    cachedId = newId;
    return newId;
  } catch (error) {
    console.warn('viewerIdentity: failed to access localStorage, falling back to in-memory id', error);
    cachedId = generateId();
    return cachedId;
  }
}

export function resetViewerIdForTesting() {
  cachedId = null;
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }
}
